import React from 'react';
import { Container, Grid, Header, Button, Image } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';

const CallToActionView = ({ data }) => {
  const imageUrl = data.image ? `${data.image}/@@images/image` : null;
  const linkUrl = data.link?.[0]?.['@id']
    ? flattenToAppURL(data.link[0]['@id'])
    : null;

  return (
    <section className="call-to-action">
      <Container>
        <Grid stackable verticalAlign="middle">
          <Grid.Row columns={2}>
            <Grid.Column>
              {data.title && <Header as="h2">{data.title}</Header>}
              <hr />
              {data.text && <p>{data.text}</p>}
              {data.buttonText && linkUrl && (
                <Button primary as="a" href={linkUrl }>
                  {data.buttonText}
                </Button>
              )}
            </Grid.Column>

            <Grid.Column>
              {imageUrl && <Image src={imageUrl} fluid rounded />}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </section>
  );
};

export default CallToActionView;
